module.exports = __webpack_public_path__ + "assets/img/A4.f48335dc.jpg";